export default __webpack_public_path__ + "static/studio-3-1-10eb051aa309476e99e75bfedc1e393b.jpg";